<!-- <router-outlet></router-outlet> -->

<div class="flex w-full flex-col">
    <mat-progress-bar mode="query" *ngIf="loading" style="position: sticky; top: 0; left: 0; z-index: 100; "></mat-progress-bar>
    <router-outlet></router-outlet>
</div>
